/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {removeActiveGoalPiggybankAppService} from '../api'

export const useMutationRemoveActiveGoalPiggybankAppService = createReactQueryMutationHook('removeActiveGoalPiggybankAppService', removeActiveGoalPiggybankAppService)
